import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { useFetchInstructors } from '@/data/swrs/instructor';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const InstructorDropdown = ({ value, onChange }) => {
	const user = useAtomValue(userInfoAtom);
	const { instructors, isError, isLoading } = useFetchInstructors(user?.token);
	
    const instructorOptions = useMemo(
		() => (Array.isArray(instructors) ? instructors.map(i => i?.name).filter(Boolean) : []),
		[instructors]
	);

	return (
		<Autocomplete
			options={instructorOptions}
			loading={isLoading}
			value={value || ''}
			onChange={(_, val) => onChange(val || '')}
			renderInput={params => (
				<TextField
					{...params}
					label="Instructor"
					error={!!isError}
					helperText={isError ? 'Failed to load instructors' : undefined}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{isLoading ? <CircularProgress size={18} /> : null}
								{params.InputProps.endAdornment}
							</>
						)
					}}
				/>
			)}
		/>
	);
};
